const $ = jQuery;
import Swal from "sweetalert2";

const levels = {
  bronze: 25,
  silver: 50,
  gold: 75,
  platinum: 98,
  diamond: 99,
};

const silver_required_actions = [107, 112];

const gold_required_actions = [114];

const platinum_required_actions = [115];

const diamond_required_actions = [116, 118];

export default class MyGamePlanLevelControl {
  constructor() {
    this.progress = $(".my_game_plan-status-bar .progress");
    this.statusList = $(".my_game_plan-status-bar .status");
    this.currentStatus = $(".my_game_plan-status-bar .current");
    this.previousLevel = CSWP.current_user_level;
    this.levelMessages = {
      gold: "You’re now a Gold Creator!",
      platinum: "You’re now a Platinum Creator!",
      diamond: "You’re now a Diamond Creator!",
    };
  }

  getCurrentLevel(completedActions) {
    let currentLevel = "bronze";
    for (const level in levels) {
      const requiredActions = this.getRequiredActions(level);
      if (this.isLevelCompleted(requiredActions, completedActions)) {
        currentLevel = level;
      } else {
        break;
      }
    }
    return currentLevel;
  }

  getNextLevel(currentLevel) {
    const levelsKeys = Object.keys(levels);
    const currentLevelIndex = levelsKeys.indexOf(currentLevel);

    // Return null if the current level is diamond
    if (currentLevel === "diamond") {
      return null;
    }

    return levelsKeys[currentLevelIndex + 1];
  }

  getRequiredActions(level) {
    switch (level) {
      case "silver":
        return silver_required_actions;
      case "gold":
        return gold_required_actions;
      case "platinum":
        return platinum_required_actions;
      case "diamond":
        return diamond_required_actions;
      default:
        return [];
    }
  }

  isLevelCompleted(requiredActions, completedActions) {
    if (requiredActions === silver_required_actions) {
      return (
        requiredActions.every((action) => completedActions.includes(action)) &&
        completedActions.length >= 5
      );
    } else {
      return requiredActions.every((action) =>
        completedActions.includes(action)
      );
    }
  }

  updateUserStatus = (currentLevel) => {
    $.ajax({
      url: CSWP.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "cs_handle_my_game_plan_level_change",
        level: currentLevel,
        _ajax_nonce: CSWP.nonce,
      },
      success: (response) => {
        if (response.success) {
          // silent update
        } else {
          console.log("Error updating level: Internal error");
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(`Error updating level: ${errorThrown}`);
      },
    });
  };

  updateLevel(completedActions) {
    const currentLevel = this.getCurrentLevel(completedActions);
    const currentWidth = levels[currentLevel];
    const nextLevel = this.getNextLevel(currentLevel);
    const nextWidth = levels[nextLevel];

    if (this.previousLevel !== currentLevel) {
      this.previousLevel = currentLevel;
      if (this.levelMessages[currentLevel]) {
        const swalLevelName =
          currentLevel.charAt(0).toUpperCase() + currentLevel.slice(1);
        Swal.fire({
          title: swalLevelName + "Level Reached!",
          width: "26em",
          customClass: {
            title: "swal2-title gc-alert-text",
            confirmButton: "the-btn third-btn",
            htmlContainer: "swal2-html-container gc-warning-text",
          },
          html: this.levelMessages[currentLevel],
          icon: "success",
        });
      }
      this.updateUserStatus(currentLevel);
    }

    this.progress.css("width", `${currentWidth}%`);

    let previousLevelWidth = 0;
    this.statusList.each((index, element) => {
      const status = $(element);
      const levelName = status.find(".level").text().toLowerCase();
      const dot = status.find(".dot");

      dot.removeClass("current completed");

      const levelWidth = levels[levelName];

      if (levelWidth <= currentWidth) {
        dot.addClass("completed");
        previousLevelWidth = levelWidth;
      } else if (levelWidth === nextWidth) {
        dot.addClass("current");
        previousLevelWidth = levelWidth - 1;
      }
    });
  }
}
